import { render, staticRenderFns } from "./AssignmentAttachments.vue?vue&type=template&id=bca378b8&scoped=true&"
import script from "./AssignmentAttachments.vue?vue&type=script&lang=ts&"
export * from "./AssignmentAttachments.vue?vue&type=script&lang=ts&"
import style0 from "./AssignmentAttachments.vue?vue&type=style&index=0&id=bca378b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bca378b8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
